import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Button, Table, message, Spin, Card, Typography, Input} from 'antd';
import {ReloadOutlined, UserOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import _ from "lodash";

const { Title } = Typography;
const { Search } = Input;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});


const AuditoriaPersona = () => {

    if(sessionStorage.getItem('user_mod'))
       sessionStorage.removeItem('user_mod');

    const { t } = useTranslation();
    const [bottom] = useState('bottomCenter');
    const [original, setOriginal] = useState([]);
    const [data, setData] = useState([]);
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState(t('global.loading'));
    const [messageApi, contextHolder] = message.useMessage();
    const [loading] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      };

    useEffect(() => {
        recargar();
    }, []);

    const filterData = data => formatter => data.map( item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const columns = [
        {
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('auditoria_persona.col_nombre')}</p>,
            dataIndex: 'nombre',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.nombre), _.isEqual),
            onFilter: (value, record) => record.nombre.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('auditoria_persona.col_papell')}</p>,
            dataIndex: 'papell',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.papell), _.isEqual),
            onFilter: (value, record) => record.papell.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('auditoria_persona.col_sapell')}</p>,
            dataIndex: 'sapell',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.sapell), _.isEqual),
            onFilter: (value, record) => record.sapell.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('auditoria_persona.col_carnet')}</p>,
            dataIndex: 'carnet',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.carnet), _.isEqual),
            onFilter: (value, record) => record.carnet.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('auditoria_persona.col_fechaeliminacion')}</p>,
            dataIndex: 'fechaeliminacion',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.fechaeliminacion), _.isEqual),
            onFilter: (value, record) => record.fechaeliminacion.startsWith(value),
        },{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('auditoria_persona.col_nombreusuario')}</p>,
            dataIndex: 'nombreusuario',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.nombreusuario), _.isEqual),
            onFilter: (value, record) => record.nombreusuario.startsWith(value),
        }
    ];

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: data.length, // Asegúrate de tener el total de elementos aquí
    });

    const handleTableChange = (newPagination) => {
        setPagination({
            ...pagination,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
    };

    const recargar = () => {
        //limpiar la busqueda del componente Search
        setSearchValue('');

        setSpinTitle(t('global.loading'));
        setSpinning(true);
        let aux = [];

        // let start = 0;
        // let limit = 1000;

        Axios.post("auditoria/getHistorialPersona",
            {
                // "start": start,
                // "limit": limit,
                // "filtro":{
                //     "idrol": 1
                // }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        key: response.data.data[i].idhistorialpersona,
                        idhistorialpersona: response.data.data[i].idhistorialpersona,
                        idpersona: response.data.data[i].idpersona,
                        nombre: response.data.data[i].nombre,
                        papell: response.data.data[i].papell,
                        sapell: response.data.data[i].sapell,
                        carnet: response.data.data[i].carnet,
                        telefono: response.data.data[i].telefono,
                        direccion: response.data.data[i].direccion,
                        correo: response.data.data[i].correo,
                        fechaeliminacion: response.data.data[i].fechaeliminacion,
                        nombreusuario: response.data.data[i].usuarioelimina,

                    });
                }
            }

            setData(aux);
            setOriginal(aux);
        }).catch(() => {
            setSpinning(false);
        })
    };

    const onSearch = (value) => {
        filterLocal(value);
    };

    const filterLocal = (value) => {
        if(value === "" || value === null){
            setData(original);
        }else{
            let aux = [];
            original.forEach(function(option) {
                if (option.carnet.toUpperCase().indexOf(value.toUpperCase()) !== -1) {
                    aux.push(option);
                }
            });
            setData(aux);
        }
    };


    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "1400px",
                    margin: "0 auto"
                }}>
                    {/* Header Card */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '8px',
                        padding: '12px',
                        marginBottom: '12px',
                        color: 'white',
                        boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px'
                            }}>
                                <UserOutlined />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Title level={4} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '16px'
                                }}>
                                    {t('auditoria_persona.title')}
                                </Title>
                                <p style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    margin: 0,
                                    fontSize: '12px'
                                }}>
                                    Auditoría personas • {data.length} registros
                                </p>
                            </div>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '8px',
                                padding: '8px 16px'
                            }}>
                                <p style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                                    {data.length} registros
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Toolbar Card */}
                    <Card style={{
                        borderRadius: '8px',
                        marginBottom: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none'
                    }} styles={{ body: { padding: '12px' } }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            flexWrap: 'wrap'
                        }}>
                            <Search
                                placeholder={t('auditoria_persona.search')}
                                style={{
                                    width: 160,
                                    height: '32px'
                                }}
                                size="small"
                                onSearch={onSearch}
                                value={searchValue}
                                onChange={(e) => {
                                    setSearchValue(e.target.value);
                                    filterLocal(e.target.value);
                                }}
                            />
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={recargar}
                                loading={loading}
                                size="small"
                                style={{
                                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                    borderColor: '#253289',
                                    color: 'white',
                                    borderRadius: '8px',
                                    height: '32px',
                                    paddingLeft: '12px',
                                    paddingRight: '12px',
                                    fontWeight: '500',
                                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                }}
                            >
                                {t('global.reload')}
                            </Button>
                        </div>
                    </Card>

                    {/* Table Card */}
                    <Card style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none'
                    }} styles={{ body: { padding: '0' } }}>
                        {contextHolder}
                        <Table
                            size="small"
                            scroll={{ y: 600 }}
                            bordered={false}
                            pagination={{
                                position: [bottom],
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '50', '100'],
                                showTotal: (total) => (
                                    <span style={{
                                        color: '#253289',
                                        fontWeight: '500'
                                    }}>
                                        Total {total} elementos
                                    </span>
                                ),
                                style: {
                                    marginTop: '8px'
                                }
                            }}
                            onChange={handleTableChange}
                            columns={columns}
                            dataSource={data}
                            onRow={() => {
                                return {
                                    onDoubleClick: async () => {
                                        // selectRowUpdate(record);
                                    },
                                    style: {
                                        cursor: 'pointer'
                                    }
                                }
                            }}
                            style={{
                                background: 'white',
                                borderRadius: '8px'
                            }}
                        />
                    </Card>
                </div>
            </Spin>
        </div>
    );
};
export default AuditoriaPersona;